import React from 'react';
import { Box, Button, Flex, Heading, Text } from '@applyboard/crystal-ui';
import { Advisor } from "../../../../assets/images";
import { ArrowRightOutlineIcon, CheckCircleOutlineIcon, MoneyDollarOutlineIcon, PersonTieOutlineIcon } from '@applyboard/ui-icons';
export var Content = function Content(_ref) {
  var handleOnClick = _ref.handleOnClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex, {
    align: "center",
    direction: "column",
    pb: 6
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Advisor, null)), /*#__PURE__*/React.createElement(Flex, {
    gap: 2,
    direction: "column",
    align: "center",
    pb: 8,
    pt: 6
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 1,
    m: 2
  }, "Third-Party Advisors"), /*#__PURE__*/React.createElement(Text, {
    intent: "secondary",
    align: "center",
    variant: "bodyL"
  }, "Connect with a third-party advisor to help you through your application process and offer support and guidance")), /*#__PURE__*/React.createElement(Flex, {
    gap: 2,
    direction: "column",
    align: "center"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 2,
    variant: "labelL"
  }, "How it works"), /*#__PURE__*/React.createElement(Flex, {
    gap: 2,
    direction: "column"
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: 3
  }, /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(PersonTieOutlineIcon, {
    intent: "primary"
  })), /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyS"
  }, "Select up to five potential advisors to work with"))), /*#__PURE__*/React.createElement(Flex, {
    gap: 3
  }, /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(CheckCircleOutlineIcon, {
    intent: "primary"
  })), /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyS"
  }, "Connect to the first agent who accepts your request"))), /*#__PURE__*/React.createElement(Flex, {
    gap: 3
  }, /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(MoneyDollarOutlineIcon, {
    intent: "primary"
  })), /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyS"
  }, "Fee based on services provided")))))), /*#__PURE__*/React.createElement(Flex, {
    justify: "center",
    align: "center"
  }, /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(Button, {
    emphasis: "contained",
    intent: "primary",
    size: "md",
    type: "button",
    width: "hug",
    trailIcon: ArrowRightOutlineIcon,
    onClick: handleOnClick
  }, "Continue"))));
};